<template>
  <div>
    <div>
      <div
        v-if="isContactsBrowse"
        class="px-4 mb-3 contacts-filters"
        @click.stop
      >
        <div class="contacts-filters__search">
          <i class="icon-search"></i>
          <input
            v-model="filterSearch"
            type="text"
            placeholder="Rechercher un contact, une entreprise, un email…"
            @keyup.enter="applyBrowseFilters"
          />
        </div>

        <div class="contacts-filters__drop">
          <button
            type="button"
            class="contacts-filters__btn"
            :class="{ 'is-active': selectedStatusIds.length > 0 }"
            @click.stop="toggleFilterMenu('status')"
          >
            Statut
            <span v-if="selectedStatusIds.length" class="contacts-filters__count">{{
              selectedStatusIds.length
            }}</span>
            <i class="icon-arrow-down"></i>
          </button>
          <div
            v-if="openFilterMenu === 'status'"
            class="contacts-filters__menu"
            @click.stop
          >
            <div class="contacts-filters__menu-head">Filtrer par statut</div>
            <label
              v-for="st in statusOptions"
              :key="'st-' + st.id"
              class="contacts-filters__menu-item"
            >
              <input
                type="checkbox"
                :value="st.id"
                :checked="selectedStatusIds.indexOf(st.id) !== -1"
                @change="toggleStatus(st.id, $event.target.checked)"
              />
              {{ st.label }}
            </label>
          </div>
        </div>

        <div class="contacts-filters__drop">
          <button
            type="button"
            class="contacts-filters__btn"
            :class="{ 'is-active': selectedJobs.length > 0 }"
            @click.stop="toggleFilterMenu('poste')"
          >
            Poste
            <span v-if="selectedJobs.length" class="contacts-filters__count">{{
              selectedJobs.length
            }}</span>
            <i class="icon-arrow-down"></i>
          </button>
          <div
            v-if="openFilterMenu === 'poste'"
            class="contacts-filters__menu contacts-filters__menu--wide"
            @click.stop
          >
            <div class="contacts-filters__menu-head">Filtrer par poste</div>
            <div class="contacts-filters__menu-search">
              <i class="icon-search"></i>
              <input
                v-model="posteMenuSearch"
                type="text"
                placeholder="Rechercher un poste…"
              />
            </div>
            <div class="contacts-filters__menu-list">
              <div
                v-if="jobsLoading"
                class="contacts-filters__menu-empty"
              >
                Chargement…
              </div>
              <template v-else>
                <label
                  v-for="job in filteredJobOptions"
                  :key="'job-' + job"
                  class="contacts-filters__menu-item"
                >
                  <input
                    type="checkbox"
                    :value="job"
                    :checked="selectedJobs.indexOf(job) !== -1"
                    @change="toggleJob(job, $event.target.checked)"
                  />
                  {{ job }}
                </label>
                <div
                  v-if="filteredJobOptions.length === 0"
                  class="contacts-filters__menu-empty"
                >
                  Aucun poste
                </div>
              </template>
            </div>
          </div>
        </div>

        <button
          type="button"
          class="contacts-filters__apply btn btn-sm btn-primary"
          :disabled="browseLoading"
          @click="applyBrowseFilters"
        >
          <i class="icon-search"></i>
          Rechercher
        </button>
      </div>

      <div v-if="isLoading">
        <LoadingSpinner />
      </div>
      <div v-else>
        <div
          id="actionsSearch"
          class="pt-2 px-4 d-flex align-items-center justify-content-between flex-wrap mb-3 contacts-toolbar"
        >
          <div class="d-flex align-items-center flex-wrap contacts-toolbar__left">
            <label v-if="isContactsBrowse" class="contacts-toolbar__selectall">
              <input
                type="checkbox"
                :checked="list.allselected"
                :disabled="browseLoading || !getTotalByUser()"
                @change="toggleSelectAllPages($event.target.checked)"
              />
              <span>
                {{ $t("lang.mycontacts.selectallpages") }} ({{ getTotalByUser() }})
              </span>
            </label>

            <span class="contacts-toolbar__results">
              Résultat :
              <small v-if="displayTotal === false" class="ml-1 text-primary"
                >{{ $t("lang.search.calculating") }}...</small
              >
              <strong v-else>{{ displayTotal }} contacts</strong>
            </span>

            <span class="contacts-toolbar__selected ml-2">
              {{
                (list.allselected ? totalSelectAll() : list.selectedIds.length) +
                " sélectionné(s)"
              }}
            </span>

          </div>

          <div class="d-flex align-items-center flex-wrap contacts-toolbar__right">
            <button
              :disabled="list.selectedIds.length == 0 || deleting"
              :class="
                list.selectedIds.length == 0 ? 'btn-secondary' : 'btn-primary'
              "
              v-if="!campaignedit && model.imported"
              type="button"
              @click="deleteImport"
              class="rounded ml-2 btn btn-sm btn-danger"
            >
              {{ $t("lang.label.remove") }}
              <span v-if="!list.allselected">{{ list.selectedIds.length }}</span>
              <span v-else>{{ totalSelectAll() }}</span>
              {{ $t("lang.search.selected") }}
            </button>

            <button
              :disabled="list.selectedIds.length == 0"
              :class="
                list.selectedIds.length == 0 ? 'btn-secondary' : 'btn-primary'
              "
              v-if="
                campaignedit && model.status !== undefined && model.status.notbuy
              "
              type="button"
              @click="deleteSelected"
              class="rounded ml-2 btn btn-sm btn-primary"
            >
              {{ $t("lang.search.deleteselectionfromcampaign") }}
            </button>

            <button
              :disabled="list.selectedIds.length == 0"
              :class="
                list.selectedIds.length == 0 ? 'btn-secondary' : 'btn-primary'
              "
              v-if="
                campaignedit && model.status !== undefined && model.status.engaged
              "
              type="button"
              @click="dactivateSelected"
              class="rounded ml-2 btn btn-sm btn-primary"
            >
              {{ $t("lang.search.removefromallcampaigns") }}
            </button>

            <button
              :disabled="list.selectedIds.length == 0"
              v-if="currentUser.role_id == 1"
              type="button"
              @click="deleteContacts"
              class="rounded ml-2 btn btn-sm btn-primary"
            >
              {{ $t("lang.button.deletecontact") }}
            </button>

            <div class="btn-group" v-if="!campaignedit">
              <button
                v-if="!model.imported && false"
                @click="saveSelected()"
                :disabled="list.selectedIds.length == 0"
                :class="
                  list.selectedIds.length > 0
                    ? 'btn-' + getColor() + '  effect-btn'
                    : ''
                "
                class="ml-2 rounded btn btn-sm btn-primary themed-button"
              >
                <i class="icon icon-save"></i> {{ $t("lang.button.save") }}
              </button>
              <div v-if="permissionFront()">
                <CampaignList
                  v-if="list.selectedIds.length > 0"
                  @addSelected="addSelected($event)"
                  @deleteSelected="deleteSelected($event)"
                  @refresh="refreshList()"
                  :key="campaignListKey"
                  :model="model"
                />
              </div>
              <template v-if="false">
                <button
                  v-show="currentUser.role_id != 4"
                  v-if="
                    (isCrmConfigSetted &&
                      !['1', '2', '4'].includes(currentUser.role_id)) ||
                    list.selectedIds.length == 0
                  "
                  :disabled="list.selectedIds.length == 0"
                  :class="
                    sending
                      ? 'btn-secondary btn-loading'
                      : list.selectedIds.length == 0
                      ? 'btn-outline-secondary'
                      : 'btn-outline-primary'
                  "
                  class="ml-2 rounded btn btn-sm"
                  @click="sendToCrm()"
                >
                  <i class="icon icon-rocket"></i>
                  {{ $t("lang.integrations.sendtomycrm") }}
                </button>

                <CrmList
                  v-else-if="
                    ['1', '2', '4'].includes(currentUser.role_id) && !lockEmails
                  "
                  @sendToCrm="sendToCrm"
                  :sending="sending"
                  :model="model"
                />
              </template>

              <button
                v-if="!this.model.imported"
                :disabled="downloading || !hasSelection()"
                :class="
                  downloading
                    ? 'btn-secondary btn-loading'
                    : !hasSelection()
                    ? 'btn-outline-secondary'
                    : 'btn-outline-primary'
                "
                class="rounded ml-2 btn btn-sm"
                @click="downloadConfirmation()"
              >
                <i class="icon-download"></i>
                <span v-if="!downloading">Télécharger la sélection</span>
                <span
                  v-else
                  class="loadingres mr-1 ml-1 spinner-border loading-spinner text-primary"
                ></span>
              </button>
            </div>

            <div
              v-if="!isLoading && getTotalByUser() > 0"
              class="contacts-pager ml-2"
              :key="paginationkey"
            >
              <select
                class="contacts-pager__size"
                :value="model.cantPerPage"
                @change="changePageSize($event.target.value)"
              >
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>

              <button
                type="button"
                class="contacts-pager__btn"
                :disabled="model.currentPage <= 1"
                @click="gotoPage(model.currentPage - 1)"
              >
                &lsaquo;
              </button>

              <template v-for="(p, idx) in pagerItems">
                <span
                  v-if="p === '…'"
                  :key="'gap-' + idx"
                  class="contacts-pager__btn contacts-pager__btn--gap"
                  >…</span
                >
                <button
                  v-else
                  :key="'pg-' + p"
                  type="button"
                  class="contacts-pager__btn"
                  :class="{ 'is-active': p === model.currentPage }"
                  @click="gotoPage(p)"
                >
                  {{ p }}
                </button>
              </template>

              <button
                type="button"
                class="contacts-pager__btn"
                :disabled="model.currentPage >= totalPages"
                @click="gotoPage(model.currentPage + 1)"
              >
                &rsaquo;
              </button>
            </div>
          </div>
        </div>
        <div class="row" v-if="downloading">
          <div class="col-12">
            <span class="blink text-primary float-right">
              {{ $t("lang.label.downloadingdata") }}</span
            >
          </div>
        </div>

        <div class="px-4 table-sticky">
          <TableV2
            v-if="!isLoading"
            :key="tablekey"
            :headers="headers"
            :cols="cols"
            :data="displayList"
            :checkbox="true"
            checkbox-field="id"
            :select-all-header="isContactsBrowse"
            :selected="list.selectedIds"
            :lock-emails="lockEmails()"
            :notselect="true"
            @selection-change="onContactsSelectionChange"
          />
        </div>

        <modal
          name="downloadmodal"
          :clickToClose="true"
          :resizable="false"
          height="auto"
          width="400px"
        >
          <div class="text-center p-4">
            <h3 class="text-primary">
              <i class="icon-download"></i>
              {{ $t("lang.planfeatures.downloadcsv") }}
            </h3>
            <a
              class="btn btn-success"
              @click="closeModal()"
              :href="vueAppRootApi + '/redirect/download?token=' + token"
              target="_blank"
              >{{ $t("lang.label.download") }}</a
            >
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import {
  crmService,
  businessContactsService,
  billingsService,
} from "@/_services";

import TableV2 from "@/components/Common/TableV2.vue";
import { formattersMixin } from "@/_mixins/";
import { mapState } from "vuex";
import CampaignList from "@/components/AccountCreation/Steps/CampaignList.vue";
import CrmList from "@/components/AccountCreation/Steps/CrmList.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  components: {
    TableV2,
    CampaignList,
    CrmList,
    LoadingSpinner,
  },
  mixins: [formattersMixin],
  props: {
    list: Object,
    total: Number,
    loading: Boolean,
    model: Object,
    clientId: Number,
    browseAsClient: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minify: true,
      token: false,
      ai: [],
      deleting: false,
      campaignListKey: 1,
      newcampaign: false,
      maxpercompany: 3,
      paginationkey: 9900,
      contactsColumns: [],
      customColumns: [],
      headers: [],
      cols: [],
      campaignedit: false,
      tablekey: 1,
      downloading: false,
      sending: false,
      limitPagination: false,
      campaignId: "",
      crmConfig: {},
      contactInfoLoading: false,
      browseLoading: false,
      browseList: [],
      browseTotal: 0,
      filterSearch: "",
      selectedStatusIds: [],
      selectedJobs: [],
      jobOptions: [],
      jobsLoaded: false,
      jobsLoading: false,
      posteMenuSearch: "",
      openFilterMenu: null,
      appliedBrowseFilters: {},
      statusOptions: [
        { id: 1, label: "New" },
        { id: 2, label: "Waiting" },
        { id: 3, label: "Analyzed" },
        { id: 4, label: "Deleted" },
        { id: 5, label: "Bounce" },
        { id: 6, label: "Duplicated" },
        { id: 7, label: "Do not contact" },
        { id: 8, label: "Not working here / Malformed email" },
        { id: 9, label: "Waiting to be enriched" },
        { id: 10, label: "Unblocked" },
        { id: 11, label: "Meeting booked" },
        { id: 12, label: "Email unavailable" },
        { id: 13, label: "Person doesnt exists" },
        { id: 14, label: "Email not found" },
        { id: 15, label: "Catch all" },
      ],
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),
    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
    isCrmConfigSetted() {
      return Object.keys(this.crmConfig).length > 0;
    },
    vueAppRootApi() {
      return process.env.VUE_APP_ROOT_API;
    },
    isContactsBrowse() {
      return !this.campaignedit && !this.model.imported;
    },
    isLoading() {
      if (this.isContactsBrowse) {
        return this.browseLoading;
      }
      return this.loading || this.contactInfoLoading;
    },
    displayList() {
      if (this.isContactsBrowse) {
        return this.browseList;
      }
      if (this.list.contacts && this.list.contacts.list) {
        return this.list.contacts.list;
      }
      return [];
    },
    displayTotal() {
      if (this.isContactsBrowse) {
        return this.browseTotal;
      }
      return this.total;
    },
    totalPages() {
      const total = Number(this.getTotalByUser()) || 0;
      const perPage = Number(this.model.cantPerPage) || 25;
      return Math.max(1, Math.ceil(total / perPage));
    },
    pagerItems() {
      const pages = this.totalPages;
      const current = Number(this.model.currentPage) || 1;
      const items = [];
      if (pages <= 7) {
        for (let i = 1; i <= pages; i++) items.push(i);
        return items;
      }
      items.push(1);
      const start = Math.max(2, current - 1);
      const end = Math.min(pages - 1, current + 1);
      if (start > 2) items.push("…");
      for (let i = start; i <= end; i++) items.push(i);
      if (end < pages - 1) items.push("…");
      items.push(pages);
      return items;
    },
    filteredJobOptions() {
      const q = (this.posteMenuSearch || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
      if (!q) {
        return this.jobOptions;
      }
      return this.jobOptions.filter((job) =>
        String(job)
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .includes(q)
      );
    },
  },
  created() {
    if (
      this.model.campaign !== undefined &&
      this.model.campaign.id !== undefined
    ) {
      this.list.noselectall = false;
      this.campaignedit = true;
      this.campaignId = this.model.campaign.id;
    }

    if (
      this.clientId != null &&
      !this.isContactsBrowse &&
      this.list.contacts &&
      this.list.contacts.list
    ) {
      this.contactInfoLoading = true;
      this.getContactInfoByClient(this.clientId, this.list.contacts.list);
    }
    this.minify = this.model.minify;
    this.getCrmSettings();
    this.list.noselectall = true;

    if (this.model.imported) {
      this.list.noselectall = false;

      businessContactsService.getCustomFields().then((response) => {
        if (response) {
          response.forEach((item, key) => {
            this.contactsColumns.push({
              name: item.label,
              name_: item.label,
              type: item.type,
              field: "custom_field_" + item.id,
            });
            this.customColumns.push({ id: item.id, label: item.label });
            this.tablekey++;
          });
        }
      });
    }

    this.list.allpageselected = false;
    if (this.list.selectedIds == undefined) {
      this.list.excludedIds = [];
      this.list.selectedIds = [];
      this.list.allselected = false;
      this.list.allpageselected = false;
      if (this.list.contacts === undefined) {
        this.list.contacts = [];
        this.list.contacts.list = [];
      }
    }
    if (!Array.isArray(this.list.excludedIds)) {
      this.$set(this.list, "excludedIds", []);
    }
    if (!Array.isArray(this.list.selectedIds)) {
      this.$set(this.list, "selectedIds", []);
    }

    if (this.list.allselected == true) {
      this.activeAll();
    }

    this.list.noselectall = false;

    this.headers = [
      {
        label: "Contact",
        size: "220px",
        value: "contact_name",
      },
      {
        label: "Poste",
        size: "180px",
        value: "job",
      },
      {
        label: "Entreprise",
        size: "200px",
        value: "business_name",
      },
      {
        label: "Email",
        size: "220px",
        value: "email",
      },
      {
        label: "Téléphone",
        size: "140px",
        value: "phone",
      },
      {
        label: "Statut",
        size: "120px",
        value: "business_contact_status_id",
      },
    ];

    this.cols = [
      [
        {
          type: "contactPerson",
          name: "contact_name",
          linkedin: "linkedinurl",
        },
      ],
      [
        {
          value: "job",
          tooltip: "job",
          truncate: 45,
          truncateWidth: "180px",
        },
      ],
      [
        {
          type: "companyInitial",
          name: "business_name",
          domain: "domain",
        },
      ],
      [
        {
          type: "emailVerifyStatus",
          value: "email",
          statusField: "business_contact_status_email",
        },
      ],
      [
        {
          type: "phoneOrEmpty",
          value: "phone",
        },
      ],
      [
        {
          type: "contactStatutBadge",
          value: "business_contact_status_id",
        },
      ],
    ];

    if (this.isContactsBrowse) {
      document.addEventListener("click", this.closeFilterMenus);
      if (this.browseAsClient) {
        this.loadBrowseContacts();
      } else {
        // Admin: seed desde la búsqueda del padre (sin refetch inmediato)
        const parentList =
          this.list.contacts && Array.isArray(this.list.contacts.list)
            ? this.list.contacts.list
            : [];
        this.browseList = parentList;
        this.browseTotal =
          this.total != null && this.total !== false ? Number(this.total) : 0;
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeFilterMenus);
  },
  watch: {
    total: function (newVal) {
      if (!this.isContactsBrowse || this.browseAsClient || this.browseLoading) {
        return;
      }
      if (newVal != null && newVal !== false) {
        this.browseTotal = Number(newVal);
      }
    },
    "list.contacts.list": function (newVal) {
      if (!this.isContactsBrowse || this.browseAsClient || this.browseLoading) {
        return;
      }
      if (Array.isArray(newVal)) {
        this.browseList = newVal;
        this.checkVisibleRows();
      }
    },
  },
  methods: {
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    closeFilterMenus() {
      this.openFilterMenu = null;
    },
    toggleFilterMenu(name) {
      const next = this.openFilterMenu === name ? null : name;
      this.openFilterMenu = next;
      if (next === "poste" && !this.jobsLoaded && !this.jobsLoading) {
        this.loadBrowseJobs();
      }
    },
    applyBrowseFilters() {
      if (this.browseLoading) {
        return;
      }
      this.openFilterMenu = null;
      this.model.currentPage = 1;
      this.clearSelection();
      this.loadBrowseContacts();
    },
    toggleStatus(id, checked) {
      const n = Number(id);
      if (checked) {
        if (this.selectedStatusIds.indexOf(n) === -1) {
          this.selectedStatusIds.push(n);
        }
      } else {
        this.selectedStatusIds = this.selectedStatusIds.filter((x) => x !== n);
      }
    },
    toggleJob(job, checked) {
      if (checked) {
        if (this.selectedJobs.indexOf(job) === -1) {
          this.selectedJobs.push(job);
        }
      } else {
        this.selectedJobs = this.selectedJobs.filter((x) => x !== job);
      }
    },
    loadBrowseJobs() {
      this.jobsLoading = true;
      businessContactsService
        .getBusinessContactsJobsList({ limit: 500 })
        .then((response) => {
          this.jobOptions = (response && response.list) || [];
          this.jobsLoaded = true;
        })
        .catch((err) => {
          console.error(err);
          this.jobOptions = [];
          this.jobsLoaded = false;
        })
        .finally(() => {
          this.jobsLoading = false;
        });
    },
    loadBrowseContacts() {
      this.browseLoading = true;
      const params = {
        currentPage: this.model.currentPage || 1,
        cantPerPage: this.model.cantPerPage || 25,
      };
      if (this.filterSearch && this.filterSearch.trim()) {
        params.search = this.filterSearch.trim();
      }
      if (this.selectedStatusIds.length) {
        params.statusIds = this.selectedStatusIds.slice();
      }
      if (this.selectedJobs.length) {
        params.jobs = this.selectedJobs.slice();
      }
      this.appliedBrowseFilters = {};
      if (params.search) {
        this.appliedBrowseFilters.search = params.search;
      }
      if (params.statusIds) {
        this.appliedBrowseFilters.statusIds = params.statusIds.slice();
      }
      if (params.jobs) {
        this.appliedBrowseFilters.jobs = params.jobs.slice();
      }

      businessContactsService
        .getBusinessContactsList(params)
        .then((response) => {
          this.browseList = (response && response.list) || [];
          this.browseTotal =
            response && response.total != null ? Number(response.total) : 0;
          if (!this.list.contacts || typeof this.list.contacts !== "object") {
            this.list.contacts = {};
          }
          this.list.contacts.list = this.browseList;
          this.$emit("update:total", this.browseTotal);
          this.checkVisibleRows();
          this.tablekey++;
        })
        .catch((err) => {
          console.error(err);
          this.browseList = [];
          this.browseTotal = 0;
          if (!this.list.contacts || typeof this.list.contacts !== "object") {
            this.list.contacts = {};
          }
          this.list.contacts.list = [];
          this.$emit("update:total", 0);
        })
        .finally(() => {
          this.browseLoading = false;
        });
    },
    onContactsSelectionChange(ids) {
      const next = Array.isArray(ids) ? ids.slice() : [];
      if (this.isContactsBrowse && this.list.allselected) {
        const previous = this.list.selectedIds || [];
        const removed = previous.filter((id) => !next.some((n) => n == id));
        const added = next.filter((id) => !previous.some((p) => p == id));

        removed.forEach((id) => {
          if (!this.list.excludedIds.some((e) => e == id)) {
            this.list.excludedIds.push(id);
          }
        });

        if (added.length) {
          this.list.excludedIds = this.list.excludedIds.filter(
            (e) => !added.some((a) => a == e)
          );
        }

        this.list.selectedIds = next;
        this.$forceUpdate();
        return;
      }

      this.list.selectedIds = next;
      this.list.allselected = false;
      this.list.allpageselected = false;
      this.$forceUpdate();
    },
    toggleSelectAllPages(checked) {
      if (checked) {
        this.selectAllPages();
      } else {
        this.clearSelection();
      }
    },
    selectAllPages() {
      this.list.allselected = true;
      this.list.allpageselected = false;
      this.list.excludedIds = [];
      this.list.selectedIds = [];
      this.checkVisibleRows();
      this.$forceUpdate();
    },
    clearSelection() {
      this.list.allselected = false;
      this.list.allpageselected = false;
      this.list.selectedIds = [];
      this.list.excludedIds = [];
      this.$forceUpdate();
    },
    checkVisibleRows() {
      if (!this.isContactsBrowse || !this.list.allselected) {
        return;
      }

      const next = (this.list.selectedIds || []).slice();
      (this.displayList || []).forEach((row) => {
        const id = row && row.id;
        if (id === undefined || id === null) {
          return;
        }
        if (this.list.excludedIds.some((e) => e == id)) {
          return;
        }
        if (!next.some((s) => s == id)) {
          next.push(id);
        }
      });

      this.list.selectedIds = next;
    },
    setExportSelection() {
      if (!this.isContactsBrowse) {
        this.model.selectedIds = this.list.selectedIds;
        this.model.selectAll = this.list.allselected;
        return;
      }

      if (this.list.allselected) {
        this.model.selectedIds = [];
        this.model.selectAll = true;
        this.model.excludedIds = (this.list.excludedIds || []).slice();
      } else {
        this.model.selectedIds = (this.list.selectedIds || []).slice();
        this.model.selectAll = false;
        this.model.excludedIds = [];
      }

      this.model.browseFilters = this.appliedBrowseFilters || {};
    },
    async requestExport() {
      this.setExportSelection();
      this.downloading = true;

      try {
        await businessContactsService.exportData(this.model, true);
        return true;
      } catch (error) {
        this.showExportError(error);
        return false;
      } finally {
        this.downloading = false;
      }
    },
    showExportError(error) {
      const alreadyQueued = error && error.status === 409;
      this.$swal({
        type: alreadyQueued ? "warning" : "error",
        title: alreadyQueued
          ? this.$t("lang.mycontacts.exportAlreadyInProgress")
          : this.$t("lang.mycontacts.exportRequestFailed"),
        text: alreadyQueued
          ? this.$t("lang.mycontacts.shippingNoticeToEmail")
          : undefined,
        showCancelButton: false,
        confirmButtonColor: alreadyQueued ? "#3085d6" : "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
      });
    },
    contactWithYourAM(){
      this.$swal({
        type: "warning",
        title: this.$t("lang.mycontacts.contact_with_am"),
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.ok"),
      }).then((result) => {

      });
    },
    showAll() {
      if (this.lockEmails()) {
        this.$router.push("/upgrade");
        return;
      }
      this.minify = false;
      this.model.minify = false;
      this.$emit("reload");
    },
    getContactInfoByClient(client_id, contact_list) {
      const bc_ids = contact_list.map((contact) => Number(contact.id));

      businessContactsService
        .getContactInfoByClient(client_id, bc_ids)
        .then((response) => {
          const serviceList = Array.isArray(response) ? response : [];
          const serviceMap = {};
          serviceList.forEach((item) => {
            serviceMap[String(item.business_contact_id)] = item;
          });

          contact_list.forEach((contact) => {
            const match = serviceMap[String(contact.id)];
            if (!match) return;

            contact.role_id = this.currentUser.role_id;
            contact.first_email_date = match.first_email_date;
            contact.last_email_date = match.last_email_date;
            contact.total_emails_sent = match.total_emails_sent;
            contact.total_manual_answers = match.total_manual_answers;
            contact.total_calendar_clics = match.total_calendar_clics;
            contact.last_calendar_clic_date = match.last_calendar_clic_date;
            contact.last_meeting_booked = match.last_meeting_booked;
            contact.total_meetings_booked = match.total_meetings_booked;

            const optionalFields = [
              "last_meeting",
              "meeting",
              "email_replies",
              "last_activity",
              "email_clicks",
            ];
            optionalFields.forEach((field) => {
              if (Object.prototype.hasOwnProperty.call(contact, field)) {
                contact[field] = match[field];
              }
            });
          });
        })
        .catch((error) => {
          console.error("Error al obtener info:", error);
        })
        .finally(() => {
          this.contactInfoLoading = false;
        });
    },
    lockEmails() {
      return (
        !this.permissionFront() &&
        !["4", "5"].includes(this.currentUser.plan_id) && 
        this.currentUser.client_id != 4496
      );
    },
    refreshList() {
      this.model.refreshlist = true;
      this.$swal({
        type: "success",
        title: this.$t("lang.campaigns_dashboard.campaignecreated"),
        text: this.$t("lang.campaigns_dashboard.addcontactsnow"),
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
      }).then((result) => {
        this.campaignListKey++;
      });
    },
    permissionFront() {
      return (
        (this.currentUser.team_role_id == undefined ||
          this.currentUser.team_role_id != 3) &&
        this.currentUser.role_id != 4
      );
    },
    selectPerCompany() {
      this.model.maxpercompany = this.maxpercompany;
    },
    openModal() {
      this.$modal.show("downloadmodal");
    },
    closeModal() {
      this.$modal.hide("downloadmodal");
      this.token = false;
    },
    getTotalByUser() {
      if (
        this.displayList !== undefined &&
        this.displayList.length > 100 &&
        this.currentUser.role_id == "2" &&
        this.currentUser.subscription_status_id == 0
      ) {
        return 100;
      }
      if (this.displayTotal == false) return 0;

      return this.displayTotal;
    },
    trialPeriod() {
      if (this.toastNotificationData.dontChargePayments == 1) {
        return false;
      }

      if (
        this.currentUser.role_id == "2" &&
        this.currentUser.subscription_status_id == 0 &&
        this.toastNotificationData.trialPeriodData.trial_period_ended == 0
      ) {
        return true;
      }
    },

    downloadConfirmation() {
      // client with plan free, but access to download contacts
      if (this.lockEmails()) {
        this.$router.push("/upgrade");
        return;
      }

      if (this.model.imported) {
        this.downloadDataCSV();
        return;
      }

      let newExportData = true;  // true  para el nuevo proceso
      if (!newExportData) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.mycontacts.exportwhytitle"),
          text: this.$t("lang.mycontacts.exportwhy"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.yes"),
        }).then((result) => {
          if (result.value) {
            this.downloadDataCSV();
          }
        });
      } else {

        this.$swal({
          type: "warning",
          title: this.$t("lang.mycontacts.shippingNoticeToEmail"),
          text: this.$t("lang.mycontacts.exportwhy"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.yes"),
        }).then(async (result) => {
          if (!result.value) {
            return;
          }
          const queued = await this.requestExport();
          if (queued) {
            this.$swal({
              type: "success",
              title: this.$t("lang.mycontacts.shippingNoticeToEmail"),
              showConfirmButton: false,
              timer: 2500,
            });
          }
        });
      }
    },

    async downloadDataCSV() {
      if (this.token) {
        this.downloading = false;
        this.openModal();
        return;
      }

      this.downloading = true;
      let datosExportar = [];
      this.setExportSelection();
      const response = await businessContactsService
        .exportData(this.model, true)
        .then((result) => {
          if (result.length == 0) {
            this.$swal({
              type: "warning",
              title: this.$t("lang.mycontacts.nocontactunlock"),
              showCancelButton: false,
              confirmButtonColor: "#d33a2c",
              confirmButtonText: this.$t("lang.button.ok"),
            }).then((result) => {});
            this.downloading = false;
            return false;
          } else {
            this.token = result.token;
            this.downloading = false;
            this.openModal();
          }
        })
        .catch((error) => {
          this.downloading = false;
          this.showExportError(error);
        });
    },

    getRowValues(indexColumn, indexBusinessContact) {
      let custom_val =
        this.list.contacts.list[indexBusinessContact].custom_values;
      let custom_cols =
        this.list.contacts.list[indexBusinessContact].custom_columns;

      if (custom_val !== null) {
        custom_val = custom_val.split(",");
        custom_cols = custom_cols.split(",");
        for (let i = 0; i < custom_cols.length; i++) {
          if (custom_cols[i] == indexColumn) return custom_val[i];
        }
      }
      return " ";
    },
    getColor() {
      if (this.model.imported) {
        return "primary";
      }

      if (this.model.status !== undefined && this.model.status.notbuy) {
        return "primary";
      }
      if (this.model.status !== undefined && this.model.status.buy) {
        return "primary";
      }
      return "primary";
    },
    deleteImport() {
      this.deleting = true;
      this.loading = true;
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: "",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
      }).then((result) => {
        if (result.value) {
          this.model.selectedIds = this.list.selectedIds;
          this.model.excludedIds = this.list.excludedIds;
          this.model.selectAll = this.list.allselected;
          businessContactsService.deleteImport(this.model).then((result) => {
            this.deleting = false;
            this.loading = false;
            this.$emit("reload");
          });
        } else {
          this.deleting = false;
          this.loading = false;
        }
      });
    },
    isActive(id) {
      return (
        this.list.selectedIds.indexOf(id) > -1 &&
        this.list.excludedIds.indexOf(id) == -1
      );
    },
    isAllActive() {
      if (this.list.allselected == true || this.list.allpageselected == true) {
        return "checked";
      }
    },
    activeAll() {
      this.list.contacts.list.forEach((element) => {
        if (this.list.selectedIds.indexOf(element.id) == -1) {
          this.list.selectedIds.push(element.id);
        }
      });
    },
    totalSelectAll() {
      return this.displayTotal - this.list.excludedIds.length;
    },
    hasSelection() {
      if (this.list.allselected) {
        return this.totalSelectAll() > 0;
      }
      return !!(this.list.selectedIds && this.list.selectedIds.length);
    },
    dactivateSelected() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.search.removefromallcampaigns"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.model.selectedIds = this.list.selectedIds;
          this.model.excludedIds = this.list.excludedIds;
          this.model.selectAll = this.list.allselected;

          businessContactsService
            .deactivateSelected(this.model)
            .then((response) => {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                showConfirmButton: false,
                timer: 1500,
              });
              this.list.selectedIds = [];
              this.list.excludedIds = [];
              this.list.allselected = false;
              this.$emit("reload");
            });
        } else {
        }
      });
    },
    deleteContacts() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.button.deletecontact"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.model.selectedIds = this.list.selectedIds;
          businessContactsService
            .deleteContacts(this.model.selectedIds)
            .then((response) => {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                showConfirmButton: false,
                timer: 1500,
              });
              this.list.selectedIds = [];
              this.list.excludedIds = [];
              this.list.allselected = false;
              this.$emit("reload");
            });
        } else {
        }
      });
    },
    deleteSelected(item) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.removecontactsfromcampaign"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          this.model.selectedIds = this.list.selectedIds;
          this.model.excludedIds = this.list.excludedIds;
          this.model.selectAll = this.list.allselected;
          if (item != undefined) {
            this.model.deleteFromCampaign = item.id;
          }
          businessContactsService
            .deleteSelected(this.model)
            .then((response) => {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                showConfirmButton: false,
                timer: 1500,
              });
              this.list.selectedIds = [];
              this.list.excludedIds = [];
              this.list.allselected = false;
              this.$emit("reload");
            });
        } else {
        }
      });
    },
    saveSelected() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
      }).then((result) => {
        if (result.value) {
          this.$swal({
            type: "success",
            title: this.$t("lang.search.waitplease"),

            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 150000,
          });

          this.model.selectedIds = this.list.selectedIds;
          this.model.excludedIds = this.list.excludedIds;
          this.model.selectAll = this.list.allselected;
          businessContactsService.saveSelected(this.model).then((response) => {
            if (response == "limitmax") {
              this.$swal({
                type: "warning",
                text: this.$t("lang.planfeatures.limitcontact"),
                showCancelButton: true,
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: this.$t("lang.button.upgrade"),
                cancelButtonText: this.$t("lang.button.ok"),
              }).then((result) => {
                if (result.value == true) {
                  this.$router.push("/upgrade");
                }
              });
            } else {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                showConfirmButton: false,
                timer: 1500,
              });
            }
            this.tablekey++;
          });
        } else {
        }
      });
    },

    sendToCrm(user_id) {
      if (this.lockEmails()) {
        this.$router.push("/upgrade");
        return;
      }

      this.sending = true;
      this.model.selectedIds = this.list.selectedIds;
      this.model.selectAll = this.list.allselected;
      if (user_id != undefined) {
        this.model.crmUserId = user_id;
      }

      billingsService.getPendingPayments().then((response) => {
        if (response) {
          this.sending = false;
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.youhavependingpayments"),
            showConfirmButton: true,
          });
          return;
        } else {
          console.log("model...", this.model);
          businessContactsService.sendToCrm(this.model).then((response) => {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              html:
                this.$t("lang.search.contactssent") +
                ": <b>" +
                response.list +
                "</b>",
              showConfirmButton: false,
              timer: 2500,
            });
            this.sending = false;
          });
        }
      });
    },

    getTitleAlertCampaignList() {
      if (this.totalSelectAll() > 25000 && this.currentUser.role_id > 1) {
        return this.$t("lang.search.25mille", { max: "25.000" });
      } else if (this.totalSelectAll() > 300000 && currentUser.role_id == 1) {
        return this.$t("lang.search.25mille", { max: "300.000" });
      }
      return "";
    },
    newCampaign() {
      this.newcampaign = true;
    },
    addSelected(item) {
      let id = item.id;
      let name = item.name;
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        html:
          this.$t("lang.campaign_parameters.addcontacttocampaign") +
          " " +
          name +
          " <br> <small><strong>" +
          this.getTitleAlertCampaignList() +
          "</strong></small>",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
      }).then((result) => {
        if (result.value) {
          this.$swal({
            type: "success",
            title: this.$t("lang.search.waitplease"),
            text: this.$t("lang.search.weareadding"),
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 150000,
          });

          this.model.selectedIds = this.list.selectedIds;
          this.model.excludedIds = this.list.excludedIds;
          this.model.selectAll = this.list.allselected;
          this.model.selectedCampaign = id;
          businessContactsService
            .insertIntoCampaign(this.model)
            .then((response) => {
              if (response == "limitmax") {
                this.$swal({
                  type: "warning",
                  text: this.$t("lang.planfeatures.limitcontact"),
                  showCancelButton: true,
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: this.$t("lang.button.upgrade"),
                  cancelButtonText: this.$t("lang.button.ok"),
                }).then((result) => {
                  if (result.value == true) {
                    this.$router.push("/upgrade");
                  }
                });
              } else {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            });
        } else {
        }
      });
    },
    toggleItem() {
      this.$forceUpdate();
    },
    getText(type) {
      if (type == 7) {
        return "Le système n'a pas encore lié la personne qui utilise cet e-mail à un contact précis. Cet e-mail est néanmoins utilisé par un membre de l'équipe de direction.";
      }
      if (type == 5) {
        return "info@...,contact@...,support@...,etc...";
      }
      if (type == 12) {
        return "buyed";
      }
      return false;
    },
    mouseover(key, bo) {
      this.ai[key] = bo;
      this.$forceUpdate();
    },
    changePage() {
      if (this.isContactsBrowse) {
        this.loadBrowseContacts();
        this.paginationkey++;
        return;
      }
      this.$emit("changePage");
      this.paginationkey++;
    },
    gotoPage(page) {
      const target = Math.min(Math.max(1, Number(page) || 1), this.totalPages);
      if (target === this.model.currentPage) {
        return;
      }
      this.model.currentPage = target;
      this.changePage();
    },
    changePageSize(size) {
      const cant = Number(size) || 25;
      if (cant === this.model.cantPerPage && this.model.currentPage === 1) {
        return;
      }
      this.model.cantPerPage = cant;
      this.model.currentPage = 1;
      this.changePage();
    },

    getSalaries(salaries) {
      if (salaries > 200) {
        return "+200";
      }
      if (salaries <= 200 && salaries > 10) {
        return "10-200";
      }
      return "1-10";
    },
    getViewBusiness(bussines_id){
      console.log(bussines_id)
      console.log("viewDash")
      let url = "/businesscontact/" + bussines_id;
      window.open(url, "_blank")
    },

    getCrmSettings() {
      crmService
        .getConfig()
        .then((result) => {
          if (result) {
            this.crmConfig = result;
          }
        })
        .catch((error) => {
          this.crmConfig = {};
        });
    },
    openOrder(order_id) {
      let url = "/orders/" + order_id;
      window.open(url, "_blank");
    },
  },
};
</script>
<style>
.blink {
  font-size: 12px;
  font-weight: 700;
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
.loadingres {
  width: 17px !important;
  height: 17px !important;
}
.btn-loading {
  position: relative;
}
img.no-interact {
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
}

/* Blur preview: viewport-sized area without .table-sticky (no scroll/sticky table chrome) */
.contacts-blur-placeholder {
  width: 100%;
  box-sizing: border-box;
  height: clamp(320px, 65vh, 85vh);
  overflow: hidden;
  border-radius: 4px;
}

.contacts-blur-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}
.btn-loading:after {
  position: absolute;
  width: 100%;
  background: blue;
  display: block;
  content: " ";
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(
    110deg,
    rgba(236, 236, 236, 0.3) 8%,
    rgba(245, 245, 245, 0.5) 18%,
    rgba(236, 236, 236, 0.3) 33%
  );
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1.8s shine linear infinite;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}
.circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
}

.contacts-toolbar__results {
  font-size: 14px;
  color: #1c1c28;
}

.contacts-toolbar__selectall {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 12px 0 0;
  padding: 4px 10px 4px 0;
  border-right: 1px solid #e3e3ee;
  font-size: 13px;
  color: #4b4be1;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
}

.contacts-toolbar__selectall input {
  margin: 0;
  cursor: pointer;
}

.contacts-toolbar__selectall input:disabled,
.contacts-toolbar__selectall input:disabled + span {
  cursor: default;
  opacity: 0.5;
}

.contacts-toolbar__selected {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eeeefc;
  color: #4b4be1;
  font-size: 12px;
  font-weight: 600;
}

.contacts-toolbar__right {
  gap: 4px;
}

.contacts-pager {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.contacts-pager__size {
  font-family: inherit;
  font-size: 12.5px;
  border: 1px solid #e8e8ee;
  border-radius: 7px;
  padding: 6px 8px;
  background: #fff;
  color: #1c1c28;
  margin-right: 8px;
  cursor: pointer;
  outline: none;
}

.contacts-pager__btn {
  min-width: 32px;
  height: 32px;
  border-radius: 7px;
  border: 1px solid #e8e8ee;
  background: #fff;
  color: #5a5a6e;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
}

.contacts-pager__btn:hover:not(:disabled):not(.is-active):not(.contacts-pager__btn--gap) {
  border-color: #4b4be1;
  color: #4b4be1;
}

.contacts-pager__btn.is-active {
  background: #4b4be1;
  border-color: #4b4be1;
  color: #fff;
}

.contacts-pager__btn--gap {
  border: none;
  cursor: default;
  background: transparent;
}

.contacts-pager__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.contacts-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.contacts-filters__apply {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 9px;
  padding: 8px 14px;
  white-space: nowrap;
}

.contacts-filters__apply:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.contacts-filters__search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e8e8ee;
  border-radius: 9px;
  padding: 9px 13px;
  background: #fff;
  min-width: 280px;
  flex: 1;
  max-width: 420px;
}

.contacts-filters__search i {
  color: #9a9aab;
  font-size: 14px;
}

.contacts-filters__search input {
  border: none;
  outline: none;
  font-size: 13px;
  color: #1c1c28;
  width: 100%;
  background: transparent;
}

.contacts-filters__drop {
  position: relative;
}

.contacts-filters__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e8e8ee;
  border-radius: 9px;
  padding: 9px 12px;
  background: #fff;
  font-size: 13px;
  color: #1c1c28;
  cursor: pointer;
}

.contacts-filters__btn.is-active {
  border-color: #4b4be1;
  color: #4b4be1;
  background: #f4f4fe;
}

.contacts-filters__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #4b4be1;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
}

.contacts-filters__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 30;
  min-width: 240px;
  max-height: 320px;
  overflow: auto;
  background: #fff;
  border: 1px solid #e8e8ee;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(28, 28, 40, 0.08);
  padding: 6px 0;
}

.contacts-filters__menu--wide {
  min-width: 300px;
}

.contacts-filters__menu-head {
  padding: 8px 12px 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9a9aab;
}

.contacts-filters__menu-search {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 8px 8px;
  border: 1px solid #e8e8ee;
  border-radius: 7px;
  padding: 6px 9px;
}

.contacts-filters__menu-search input {
  border: none;
  outline: none;
  font-size: 12.5px;
  width: 100%;
  background: transparent;
}

.contacts-filters__menu-list {
  max-height: 220px;
  overflow: auto;
}

.contacts-filters__menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin: 0;
  font-size: 13px;
  color: #1c1c28;
  cursor: pointer;
}

.contacts-filters__menu-item:hover {
  background: #f7f7fa;
}

.contacts-filters__menu-empty {
  padding: 12px;
  text-align: center;
  color: #9a9aab;
  font-size: 13px;
}
</style>
